import { render, staticRenderFns } from "./MyPlanNew.vue?vue&type=template&id=a0b1cb04&scoped=true"
import script from "./MyPlanNew.vue?vue&type=script&lang=js"
export * from "./MyPlanNew.vue?vue&type=script&lang=js"
import style0 from "./MyPlanNew.vue?vue&type=style&index=0&id=a0b1cb04&prod&lang=scss&scoped=true"
import style1 from "./MyPlanNew.vue?vue&type=style&index=1&id=a0b1cb04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b1cb04",
  null
  
)

export default component.exports